import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedProducts from './components/FeaturedProducts';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import ArticleCards from './components/ArticleCards';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Pandabuy.beer',
  url: 'https://pandabuy.beer',
  description: 'Discover the best Pandabuy Spreadsheet with 20,000+ products across 14 categories. Updated daily with verified links for sneakers, hoodies, bags, accessories, and more.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://pandabuy.beer/?s={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeaturedProducts />
      <AboutSection />
      <CTASection />
      <ArticleCards />
      <Testimonials />
      <FAQSection />
      <Footer />
    </main>
  );
}